export default "__VITE_ASSET__Bl$f4xSu__"